/**
* Created by lobin on 2020/6/18.
*/
<template>
  <div class="cabinet-add">
    <a-modal v-model="visible" title="批量添加格子" @ok="handleOk" width="800px" @cancel="cancelHandle">
      <a-table
        :columns="columns"
        :data-source="data"
        bordered size="middle"
        :pagination="false"
        :scroll="{ y: 300 }"
        rowKey="serial"
      >
        <template
            v-for="col in ['serial', 'channel']"
            :slot="col"
            slot-scope="text, record"
        >
          <div>
            <a-input-number
                v-if="record.editable"
                style="margin: -5px 0"
                :value="text"
                @change="e => handleChange(e.target.value, record.key, col)"
            />
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template
            slot="type"
            slot-scope="text, record"
        >
          <div>
            <a-radio-group
                v-if="record.editable"
                default-value="small"
                button-style="solid"
                style="margin: -5px 0"
                :value="text"
                @change="e => handleChange(e.target.value, record.key, 'type')"
            >
              <a-radio-button value="mini">迷你</a-radio-button>
              <a-radio-button value="small">小</a-radio-button>
              <a-radio-button value="middle">中</a-radio-button>
              <a-radio-button value="big">大</a-radio-button>
              <a-radio-button value="huge">超大</a-radio-button>
            </a-radio-group>
            <template v-else>
              <span v-if="text === 'mini'">迷你</span>
              <span v-if="text === 'small'">小</span>
              <span v-if="text === 'middle'">中</span>
              <span v-if="text === 'big'">大</span>
              <span v-if="text === 'huge'">超大</span>
            </template>
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="editable-row-operations">
        <span v-if="record.editable">
          <a @click="() => save(record.key)">保存</a>
          <a-divider type="vertical" />
          <a @click="cancel(record.key)">取消</a>
        </span>
        <span v-else>
          <a :disabled="editingKey !== ''" @click="() => edit(record.key)">编辑</a>
          <a-divider type="vertical" />
          <a :disabled="editingKey !== ''" @click="() => del(record.key)">删除</a>
        </span>
          </div>
        </template>
      </a-table>
      <a-button type="dashed" icon="plus" style="width:100%;margin-top: 10px" @click="addItem">
        添加
      </a-button>
    </a-modal>
  </div>
</template>

<script type="text/babel">
import { batchaddconfig, createCabinet } from '@/api/cabinet';

function isNumber(obj) {
  return Object.prototype.toString.call(obj) === '[object Number]';
}

const columns = [
  {
    title: '编号',
    dataIndex: 'serial',
    scopedSlots: { customRender: 'serial' },
  },
  {
    title: '组',
    dataIndex: 'cabnum',
  },
  {
    title: '规格',
    className: 'type',
    dataIndex: 'type',
    width: 280,
    scopedSlots: { customRender: 'type' },
  },
  {
    title: '通道',
    dataIndex: 'channel',
    scopedSlots: { customRender: 'channel' },
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  data() {
    return {
      stationId: '',
      num: 22,
      visible: false,
      data: [],
      columns,
      editingKey: '',
    };
  },
  methods: {
    addItem() {
      const listLength = this.data.length + 1;
      this.data.push({
        key: listLength,
        serial: listLength,
        type: 'small',
        channel: listLength,
      });
    },
    show(stationId, option) {
      console.log(option);
      this.stationId = stationId;
      // this.getBatchAddConfig();
      this.genConfig(option);
      this.visible = true;
    },
    genConfig({
      type, 
      num, 
      start, 
      cabstart,
      sort,
    }) {
      const tmp = {
        normal: [
          {
            key: 1,
            serial: 1,
            type: 'big',
            channel: 1,
          },
          {
            key: 2,
            serial: 2,
            type: 'middle',
            channel: 2,
          },
          {
            key: 3,
            serial: 3,
            type: 'small',
            channel: 3,
          },
          {
            key: 4,
            serial: 4,
            type: 'small',
            channel: 4,
          },
          {
            key: 5,
            serial: 5,
            type: 'small',
            channel: 5,
          },
          {
            key: 6,
            serial: 6,
            type: 'small',
            channel: 6,
          },
          {
            key: 7,
            serial: 7,
            type: 'small',
            channel: 7,
          },
          {
            key: 8,
            serial: 8,
            type: 'small',
            channel: 8,
          },
          {
            key: 9,
            serial: 9,
            type: 'middle',
            channel: 9,
          },
          {
            key: 10,
            serial: 10,
            type: 'middle',
            channel: 10,
          },
          {
            key: 11,
            serial: 11,
            type: 'middle',
            channel: 11,
          },
          {
            key: 12,
            serial: 12,
            type: 'big',
            channel: 12,
          },
          {
            key: 13,
            serial: 13,
            type: 'middle',
            channel: 13,
          },
          {
            key: 14,
            serial: 14,
            type: 'small',
            channel: 14,
          },
          {
            key: 15,
            serial: 15,
            type: 'small',
            channel: 15,
          },
          {
            key: 16,
            serial: 16,
            type: 'small',
            channel: 16,
          },
          {
            key: 17,
            serial: 17,
            type: 'small',
            channel: 17,
          },
          {
            key: 18,
            serial: 18,
            type: 'small',
            channel: 18,
          },
          {
            key: 19,
            serial: 19,
            type: 'small',
            channel: 19,
          },
          {
            key: 20,
            serial: 20,
            type: 'middle',
            channel: 20,
          },
          {
            key: 21,
            serial: 21,
            type: 'middle',
            channel: 21,
          },
          {
            key: 22,
            serial: 22,
            type: 'middle',
            channel: 22,
          },
        ],
        mini: [
          {
            key: 1,
            serial: 1,
            type: 'mini',
            channel: 1,
          },
          {
            key: 2,
            serial: 2,
            type: 'mini',
            channel: 2,
          },
          {
            key: 3,
            serial: 3,
            type: 'mini',
            channel: 3,
          },
          {
            key: 4,
            serial: 4,
            type: 'mini',
            channel: 4,
          },
          {
            key: 5,
            serial: 5,
            type: 'mini',
            channel: 5,
          },
          {
            key: 6,
            serial: 6,
            type: 'mini',
            channel: 6,
          },
          {
            key: 7,
            serial: 7,
            type: 'mini',
            channel: 7,
          },
          {
            key: 8,
            serial: 8,
            type: 'mini',
            channel: 8,
          },
          {
            key: 9,
            serial: 9,
            type: 'mini',
            channel: 9,
          },
          {
            key: 10,
            serial: 10,
            type: 'mini',
            channel: 10,
          },
          {
            key: 11,
            serial: 11,
            type: 'mini',
            channel: 11,
          },
          {
            key: 12,
            serial: 12,
            type: 'mini',
            channel: 12,
          },
          {
            key: 13,
            serial: 13,
            type: 'mini',
            channel: 13,
          },
          {
            key: 14,
            serial: 14,
            type: 'mini',
            channel: 14,
          },
          {
            key: 15,
            serial: 15,
            type: 'mini',
            channel: 15,
          },
          {
            key: 16,
            serial: 16,
            type: 'mini',
            channel: 16,
          },
          {
            key: 17,
            serial: 17,
            type: 'mini',
            channel: 17,
          },
          {
            key: 18,
            serial: 18,
            type: 'mini',
            channel: 18,
          },
          {
            key: 19,
            serial: 19,
            type: 'mini',
            channel: 19,
          },
          {
            key: 20,
            serial: 20,
            type: 'mini',
            channel: 20,
          },
        ],
      };
      const result = [];
      const tmpData = tmp[type];
      for (let i = 0; i < num; i++) {
        for (let n = 0; n < tmpData.length; n++) {
          const item = tmpData[n];
          result.push({
            cabnum: cabstart + i,
            stationId: this.stationId,
            key: start - 1 + i * tmpData.length + item.serial,
            serial: start - 1 + i * tmpData.length + item.serial,
            type: item.type,
            channel: this.getChannel(n, type, sort),
          });
        }
      }
      this.data = result;
    },
    getChannel(n, type, sort) {
      if(sort === 'normal') {
        return n + 1;
      } else {
        if(type === 'normal') {
          return n < 11 ? 12 + n : n - 10;
        } else {
          return n < 10 ? 11 + n : n - 9;
        }
      }
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    async getBatchAddConfig() {
      const { data } = await batchaddconfig(this.stationId);
      this.data = data;
    },
    del(key) {
      const newData = [];
      for (let i = 0; i < this.data.length; i += 1) {
        const item = this.data[i];
        if (item.key !== key) {
          newData.push(item);
        }
      }
      this.data = newData;
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (this.checkListItem(target)) {
        const targetCache = newCacheData.filter((item) => key === item.key)[0];
        if (target && targetCache) {
          delete target.editable;
          this.data = newData;
          Object.assign(targetCache, target);
          this.data = newCacheData;
        }
        this.editingKey = '';
      }
    },
    checkListItem({ serial, type, channel }) {
      let res = true;
      if (!isNumber(serial)) {
        res = false;
        this.$message.error('编号必须为数字');
      }
      if (!isNumber(channel)) {
        res = false;
        this.$message.error('通道必须为数字');
      }
      if (!['small', 'middle', 'big'].includes(type)) {
        res = false;
        this.$message.error('规格必须是small|middle|big');
      }
      return res;
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = '';
      if (target) {
        Object.assign(target, this.data.filter((item) => key === item.key)[0]);
        delete target.editable;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    async handleOk() {
      const list = this.data;
      const { data } = await createCabinet({
        stationId: this.stationId,
        cabnum: this.cabnum,
        list,
      });
      if (data) {
        this.cancelHandle();
        this.$message.success('添加成功');
      }
    },
    cancelHandle() {
      this.visible = false;
      this.$emit('cancel');
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.station {
}
</style>
